import { createContext, useCallback, useMemo, useState } from "react";

export interface SupportHelpContextType {
  onHelpClick?: (() => void) | undefined;
  setOnHelpClick: (callback: (() => void) | undefined) => void;
  pendingPageContext?: Record<string, unknown>;
  setPendingPageContext: (context: Record<string, unknown> | undefined) => void;
}

export const SupportHelpContext = createContext<SupportHelpContextType>({
  onHelpClick: undefined,
  setOnHelpClick: () => {},
  pendingPageContext: undefined,
  setPendingPageContext: () => {},
});

export interface SupportHelpProviderProps {
  children: React.ReactNode;
}

export function SupportHelpProvider({ children }: SupportHelpProviderProps) {
  const [onHelpClick, setOnHelpClickState] = useState<(() => void) | undefined>(
    undefined,
  );
  const [pendingPageContext, setPendingPageContext] = useState<
    Record<string, unknown> | undefined
  >(undefined);

  const setOnHelpClick = useCallback((callback: (() => void) | undefined) => {
    setOnHelpClickState(() => callback);
  }, []);

  const contextValue = useMemo(
    () => ({
      onHelpClick,
      setOnHelpClick,
      pendingPageContext,
      setPendingPageContext,
    }),
    [onHelpClick, setOnHelpClick, pendingPageContext, setPendingPageContext],
  );

  return (
    <SupportHelpContext.Provider value={contextValue}>
      {children}
    </SupportHelpContext.Provider>
  );
}
